export const getValorCampo= (elemento, nombreCampo, valorDefecto = undefined) => {
    if (!elemento)
        return "";
    //console.log("elemento:", elemento);
    //console.log("nombreCampo: ", nombreCampo);
    return nombreCampo.split('.')
        .reduce((acc, subcampo) =>  acc && acc[subcampo] !== undefined ? acc[subcampo] : valorDefecto
            , elemento);
}